import {List, ShowMoreText} from '@/ui-kit';
import {prepareDataSource} from './utils';
import styles from './event.module.scss';

const renderItem = ({label, value}) => (
  <List.Item className={styles.item}>
    <div className={styles.itemLabel}>
      <strong>{label}:</strong>
    </div>
    <div className={styles.itemValue}>
      <ShowMoreText lines={1} anchorClass={styles.showMoreAnchor}>
        {value}
      </ShowMoreText>
    </div>
  </List.Item>
);

export const Event = ({event, entity}) => {
  const {commonData, extraData} = prepareDataSource(event, entity);

  return (
    <div key={event.id} className={styles.wrapper}>
      <div className={styles.event} key={event.id}>
        <List dataSource={commonData} renderItem={renderItem} />
        {extraData && <List dataSource={extraData} renderItem={renderItem} />}
      </div>
    </div>
  );
};
